/**
 * API endpoint path constants. Grouped by domain for discoverability.
 * Exported as flat object for backward compatibility (endpoints.login, endpoints.menus, etc.).
 */
const auth = {
  login: 'login',
  register: 'register',
  logout: 'logout',
  changePassword: 'change/password',
  resetPassword: 'password/reset',
  updatePassword: 'password/update',
  sendOTP: 'resend/otp',
  verifyOTP: 'verify/otp',
};

const profile = {
  profile: 'profile',
  statistics: 'statistics',
  deleteAccount: 'delete',
  deactivate: 'deactivate',
};
const subscriptions = {
  subscriptions: 'subscriptions',
  mySubscriptionsnew: 'customer_subscriptions/new',
  mySubscriptions: 'customer_subscriptions',
  subData: 'my-customer-subscriptions',
  subscriptionSubscribe: 'subscription/subscribe',
  subscriptionValidate: 'subscription/validate-subscribe',
  subscriptionCustomValidate: 'customer_subscriptions/purchase/custom',
  subscriptionCustom: 'subscription/custom-subscribe',
  subscriptionAddons: 'subscription-addons',
  subscriptionCoupon: 'coupons/validate',
  subscriptionStart: 'subscription/start',
  subscriptionFreeze: 'customer_subscriptions/freeze',
  subscriptionUnFreeze: 'customer_subscriptions/unfreeze',
  subscriptionUpgrade: 'customer_subscriptions/upgrade',
  subscriptionCancel: 'customer_subscriptions/cancel',
  generatePayURL: 'customer_subscriptions/generate/charge_url',
  deliverAddressDates: 'customer_subscriptions/set/delivery/address',
  upgradeItems: 'customer_subscriptions/upgrade/items',
  upgradeSubscription: 'customer_subscriptions/upgrade/purchase',

};

const menu = {
  mealBooking: 'select/menu_items',
  clearMenu: 'clear/menu_items',
  menus: 'menu_builders',
  menu_replace: 'replaceable/menu_builders',
  menuSubscriptions: 'menu_subscriptions',
  menuDetails: 'menu-details',
  menuItems: 'menu_items',
  clearSelections: 'clear/menu_items',
  assign_default_menu_items: 'assign/default_menu_items',
};

const orders = {
  order: 'order',
  orders: 'orders',
  driver_notes: 'driver_notes',
};

const addresses = {
  openAddress: 'open-address',
  addresses: 'addresses',
  address: 'addresses',
  setDefault: 'addresses/set/default',
  areas: 'areas',
  slots: 'area/slots',
};

const content = {
  slider: 'banners',
  configuration: 'initial',
  appConfig: 'app_config',
  cms: 'pages',
  celebrities: 'celebrities',
};

export const endpointsByDomain = {
  auth,
  profile,
  subscriptions,
  menu,
  orders,
  addresses,
  content,
  calendar: { calendar: 'calendar' },
  feedback: { sendRating: 'feedback' },
  preferences: { allergies: 'allergies', dislikes: 'dislikes' },
  consultations: { consultants: 'consultants', consultations: 'consultations', bookConsultants: 'book/consultations' },
  notifications: { notifications: 'notifications', notificationsUpdate: 'notifications/update' },
  community: { posts: 'posts', reaction: 'posts/reaction', comments: 'comments' },
  other: { calculate_calories: 'calculate/calories', myReferral: 'referral', loyalty: 'loyalty' },
};

/** Flat map for existing usage: endpoints.login, endpoints.menus, etc. */
export const endpoints = {
  ...auth,
  ...profile,
  ...subscriptions,
  ...menu,
  ...orders,
  ...addresses,
  ...content,
  sendRating: 'feedback',
  allergies: 'allergies',
  dislikes: 'dislikes',
  allergy_dislikes: 'allergy_dislikes',
  allergy_dislike_category: 'allergy_dislike_categories',
  consultants: 'consultants',
  consultations: 'consultations',
  bookConsultants: 'book/consultations',
  notifications: 'notifications',
  notificationsUpdate: 'notifications/update',
  posts: 'posts',
  reaction: 'posts/reaction',
  comments: 'comments',
  calculate_calories: 'calculate/calories',
  myReferral: 'referral',
  loyalty: 'loyalty',
  calendar: 'calendar',
  profile: 'profile',
};
